import { filter } from "rxjs/operators";
import { Component, OnInit, ViewChild } from "@angular/core";
import { Product } from "../../models/product.model";
import { ProductsService } from "../../services/products.service";
import { cantidadesService } from "../../services/cantidades.service";
import {
    ModalController,
    LoadingController,
    IonInfiniteScroll,
    ToastController,
} from "@ionic/angular";
import { GlobalService } from "../../services/global.service";
import { CartService } from "./../../services/cart.service";
import { CartComponent } from "../cart/cart.component";
import { ApiService } from "../../api.service";
import { Storage } from "@ionic/storage";
import { PopoverController } from "@ionic/angular";
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
//import { ShareComponent } from "./../../components/share/share.component";

@Component({
    selector: "app-products",
    templateUrl: "./products.component.html",
    styleUrls: ["./products.component.scss"],
})
export class ProductsComponent implements OnInit {
    @ViewChild(IonInfiniteScroll, { static: false })
    infiniteScroll: IonInfiniteScroll;

    constructor(
        public ctdadService: cantidadesService,
        public popoverController: PopoverController,
        public productsService: ProductsService,
        public storage: Storage,
        public modalController: ModalController,
        public global: GlobalService,
        public loadingController: LoadingController,
        public toastController: ToastController
    ) { }

    private products: Product[];
    private searchTerm = "";
    private rutaimagen = "";
    private total: any;
    private nophoto = "";
    private grid: Boolean = true;
    private oneColumn: Boolean = false;

    ngOnInit() {
        this.products = this.global.products;
        this.nophoto = this.global.url + "imagenes/NOFOTO.JPG";
        if (this.products === undefined || this.products == null) {
            this.presentLoading();
            this.getProductList();
        }
    }

    ionViewDidEnter() {
        this.products = [];
        this.getProductList();
    }

    onError(item) {
        item.imagen = this.nophoto;
    }    
    
    presentLoading() {
        this.loadingController
            .create({
                cssClass: "my-custom-class",
                message: "Cargando productos...",
            })
            .then((res) => {
                res.present();

                res.onDidDismiss().then((dis) => {
                });
            });

        setTimeout(() => {
            this.loadingController
                .dismiss()
                .then((res) => {
                })
                .catch((error) => {
                });
        }, 3000);
    }



    // Get List of Products
    getProductList() {
        this.productsService.productList().then((products) => {
            this.products = products;
            this.global.products = products;

            for (
                let i = 0;
                i < Object.keys(this.global.cartProducts.articulos).length;
                i++
            ) {
                let found = this.products.find(
                    (x) =>
                        x.codigo ===
                        this.global.cartProducts.articulos[i].codigo
                );
                if (found != null) {
                    found.cesta = true;
                    found.unid1 = this.global.cartProducts.articulos[i].unid1;
                    found.unid2 = this.global.cartProducts.articulos[i].unid2;
                }


                found = null;
            }

            this.loadingController
                .dismiss()
                .then((res) => {
                })
                .catch((error) => {
                });

        });
    }

    // Go to cart page function
    async gotoCartPage() {
        this.dismiss();
        const modal = await this.modalController.create({
            component: CartComponent,
        });
        modal.onDidDismiss().then((data) => {
            this.searchTerm = "";
            this.getProductList();
        });
        return await modal.present();
    }
    // Back to previous page function
    dismiss() {
        this.modalController.dismiss({
            dismissed: true,
        });
    }

    // A una columna
    showOneColumn() {
        this.oneColumn = true;
        this.grid = false;
    }

    // En Grid
    showGrid() {
        this.grid = true;
        this.oneColumn = false;
    }
}
